import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

@inject('commonStore')
@observer
class ConfirmDialog extends Component {
  handleClickConfirm = () => {
    this.props.commonStore.confirmDialog.onConfirm();
    this.handleClickCancel();
  };

  handleClickCancel = () => {
    this.props.commonStore.confirmDialog.isOpen = false;
  };

  render() {
    const { t, commonStore } = this.props;
    return (
      <Dialog open={commonStore.confirmDialog.isOpen} onClose={() => this.handleClickCancel()}>
        <DialogTitle>{commonStore.confirmDialog.description}</DialogTitle>
        <DialogActions>
          <Button variant="contained" onClick={() => this.handleClickConfirm()} autoFocus>
            {t('common.button.confirm')}
          </Button>
          <Button onClick={() => this.handleClickCancel()} color="secondary">
            {t('common.button.cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withTranslation()(ConfirmDialog);
